module.exports = __webpack_public_path__ + "static/media/boy_with_dog.91853c92.png";